import { createAsyncThunk } from '@reduxjs/toolkit';
import Cookies from 'js-cookie'; 


export const getIndustries = createAsyncThunk(
    'get/Industries',
    async (_, { rejectWithValue }) => {
      try {
        const token = Cookies.get(process.env.NEXT_PUBLIC_COOKIE_NAME ?? `cr_${process.env.NEXT_PUBLIC_COOKIE_DOMAIN_SCOPE}_token` );

        if (!token) {
          throw new Error('Authorization token not found');
        }

        const response = await fetch(`${process.env.NEXT_PUBLIC_API_PATH}industries`, {
          method: 'GET',
          headers: { 
            'Content-Type': 'application/json',
            'Authorization': `${token}`, 

           },
        });
  
        if (!response.ok) {
          throw new Error('Failed get industries');
        }
  
        const data = await response.json();
        return data.data;
      } catch (error: any) {
        return rejectWithValue(error.message);
      }
    }
  );

  export const getRecommendationSources = createAsyncThunk(
    'get/RecommendationSources',
    async (_, { rejectWithValue }) => {
      try {
        const token = Cookies.get(process.env.NEXT_PUBLIC_COOKIE_NAME ?? `cr_${process.env.NEXT_PUBLIC_COOKIE_DOMAIN_SCOPE}_token` );

        // if (!token) {
        //   throw new Error('Authorization token not found');
        // }

        const response = await fetch(`${process.env.NEXT_PUBLIC_API_PATH}recommender-sources`, {
          method: 'GET',
          headers: { 
            'Content-Type': 'application/json',
            'Authorization': `${token}`, 

           },
        });
  
        if (!response.ok) {
          throw new Error('Failed get industries');
        }
  
        const data = await response.json();
        return data.data;
      } catch (error: any) {
        return rejectWithValue(error.message);
      }
    }
  );

  export const getQrCode = createAsyncThunk(
    'get/get-qr',
    async (_, { rejectWithValue }) => { 
      try {
        const token = Cookies.get(process.env.NEXT_PUBLIC_COOKIE_NAME ?? `cr_${process.env.NEXT_PUBLIC_COOKIE_DOMAIN_SCOPE}_token` );
        const response = await fetch(`${process.env.NEXT_PUBLIC_API_PATH}get-qr`, {
          method: 'GET',
          headers: {
            'Authorization': `${token}`,
          },
        });
  
        if (!response.ok) {
          throw new Error('Failed to get QR');
        }
  
        const data = await response.json();
        
        if (Array.isArray(data.data)) {
          return null;
        }

        return data.data
  
      } catch (error: any) {
        return rejectWithValue(error.message);
      }
    }
  );

  export const getPDF = createAsyncThunk(
    'get/PDF',
    async (_, { rejectWithValue }) => { 
      try {
        const token = Cookies.get(process.env.NEXT_PUBLIC_COOKIE_NAME ?? `cr_${process.env.NEXT_PUBLIC_COOKIE_DOMAIN_SCOPE}_token` );
        const response = await fetch(`${process.env.NEXT_PUBLIC_API_PATH}generate-pdf`, {
          method: 'GET',
          headers: {
            'Authorization': `${token}`,
          },
        });

        const contentType = response.headers.get('Content-Type');

        if (contentType && contentType.includes('application/json')) {
          const errorJson = await response.json();
          if (errorJson.status === 'failed') {
            return rejectWithValue('failed');
          }
        }
  
        if (!response.ok) {
          throw new Error('Failed to get PDF');
        }
  
        const blob = await response.blob();
        const url = window.URL.createObjectURL(blob);
  
        const link = document.createElement('a');
        link.href = url;
        link.download = 'Candidate Review - Profile.pdf'; 
        document.body.appendChild(link);
        link.click();
  
        document.body.removeChild(link);
        window.URL.revokeObjectURL(url);
  
        return true; // Success
  
      } catch (error: any) {
        return rejectWithValue(error.message);
      }
    }
  );

  export const downloadQR = createAsyncThunk(
    'download-qr',
    async ({ theme }: {theme:string}, { rejectWithValue }) => { 
      try {
        const token = Cookies.get(process.env.NEXT_PUBLIC_COOKIE_NAME ?? `cr_${process.env.NEXT_PUBLIC_COOKIE_DOMAIN_SCOPE}_token` );
        const response = await fetch(`${process.env.NEXT_PUBLIC_API_PATH}download-qr`, {
          method: 'POST',
          headers: { 
            'Content-Type': 'application/json',
            'Authorization': `${token}`,
           },
          body: JSON.stringify({theme }),
        });
  
        if (!response.ok) {
          throw new Error('Failed to download QR');
        }
  
        const blob = await response.blob();
        const url = window.URL.createObjectURL(blob);
  
        const link = document.createElement('a');
        link.href = url;
        link.download = 'Candidate Review - QR.pdf'; 
        document.body.appendChild(link);
        link.click();
  
        document.body.removeChild(link);
        window.URL.revokeObjectURL(url);
  
        return true; // Success
  
      } catch (error: any) {
        return rejectWithValue(error.message);
      }
    }
  );

  export const downloadStamp = createAsyncThunk(
    'download-stamp',
    async ({ theme }: {theme:string}, { rejectWithValue }) => { 
      try {
        const token = Cookies.get(process.env.NEXT_PUBLIC_COOKIE_NAME ?? `cr_${process.env.NEXT_PUBLIC_COOKIE_DOMAIN_SCOPE}_token` );
        const response = await fetch(`${process.env.NEXT_PUBLIC_API_PATH}download-stamp`, {
          method: 'POST',
          headers: { 
            'Content-Type': 'application/json',
            'Authorization': `${token}`,
           },
          body: JSON.stringify({theme }),
        });
  
        if (!response.ok) {
          throw new Error('Failed to get Stamp');
        }


      const blob = await response.blob(); // Convert response to binary data (PNG)
      const url = window.URL.createObjectURL(blob); // Create a URL for the file

      const link = document.createElement('a');
      link.href = url;
      link.style.display = 'none'; // Hide the link element
      link.download = 'Candidate Review - Stamp.png'; 
      document.body.appendChild(link);
      link.click(); // Trigger the download
      document.body.removeChild(link); // Remove the link after download

      window.URL.revokeObjectURL(url); // Clean up memory

      return true;
      } catch (error: any) {
        return rejectWithValue(error.message);
      }
    }
  );

  export const getUserLocation = createAsyncThunk(
    'get/location',
    async (_, { rejectWithValue }) => {
      try {

        const response = await fetch(`${process.env.NEXT_PUBLIC_API_PATH}country`, {
          method: 'GET',
          headers: { 
            'Content-Type': 'application/json',
           },
        });
  
        if (!response.ok) {
          throw new Error('Failed to get ');
        }
  
        const data = await response.json();
        return data.data;
      } catch (error: any) {
        return rejectWithValue(error.message);
      }
    }
  );

  export const saveSubscription = createAsyncThunk(
    'get/saveSubscription',
    async (_, { rejectWithValue }) => {
      try {
        const token = Cookies.get(process.env.NEXT_PUBLIC_COOKIE_NAME ?? `cr_${process.env.NEXT_PUBLIC_COOKIE_DOMAIN_SCOPE}_token` );

        if (!token) {
          throw new Error('Authorization token not found');
        }

        const response = await fetch(`${process.env.NEXT_PUBLIC_API_PATH}save-subscription`, {
          method: 'POST',
          headers: { 
            'Content-Type': 'application/json',
            'Authorization': `${token}`, 

           },
        });
  
        if (!response.ok) {
          throw new Error('Failed save subscription');
        }

        const data = await response.json();
        return data;
      } catch (error: any) {
        return rejectWithValue(error.message);
      }
    }
  );

  
  